import type { Entry, EntrySkeletonType } from "contentful";

import { H2 } from "~/components/ui/text";
import type { SerializeFrom } from "~/lib/types";

import type { TypeTilesSkeleton } from "../compiled";
import { isTypeTiles } from "../compiled";
import { Tiles } from "./tiles";

export const HomePageSections = ({
  sections,
  title,
  className,
  fixedHeight = false,
}: {
  sections: Array<SerializeFrom<
    Entry<EntrySkeletonType, "WITHOUT_UNRESOLVABLE_LINKS", string>
  > | null>;
  title?: string;
  className?: string;
  fixedHeight?: boolean;
}) => {
  if (!sections || sections.length === 0) return null;

  return (
    <div className={className}>
      {title && (
        <H2 className="leading-lg text-brand-primary-black my-2 mb-8 border-b-0 text-[26px] font-semibold lg:text-[32px]">
          {title}
        </H2>
      )}

      {sections.map(section => {
        if (!section) return null;

        // Check if the section is a TypeTiles entry
        if (isTypeTiles(section)) {
          return (
            <div key={section.sys.id} className="mb-8">
              <Tiles
                content={
                  section as SerializeFrom<
                    Entry<
                      TypeTilesSkeleton,
                      "WITHOUT_UNRESOLVABLE_LINKS",
                      string
                    >
                  >
                }
                className=""
                fixedHeight={fixedHeight}
              />
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};
